import React from 'react';

import { Table, Tag } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { defaultPaginationConfig } from 'segments/utils/constants/common';

import { convertTransactionsToTable, Transaction, TransactionType, transactionTypeTitles } from 'features/transactions';


interface TableData extends Omit<Transaction, 'amount'> {
  amount: string;
}

type Props = {
  items: Transaction[] | never[];
  itemsTotal?: number;
  currentPage?: number;
  defaultPageSize?: number;
  isLoading?: boolean;
  onUserIdClick: (userId: number | string) => void;
  onPageChange?: (page: number, pageSize: number) => void;
};

export const TransactionsTable = (props: Props) => {
  const {
    items,
    itemsTotal,
    currentPage,
    defaultPageSize,
    isLoading,
    onPageChange,
    onUserIdClick,
  } = props;

  const { t } = useTranslation(undefined, { keyPrefix: 'table' });

  return (
    <Table
      dataSource={convertTransactionsToTable(items)}
      loading={isLoading}
      size="small"
      scroll={{ x: 1160 }}
      pagination={{
        ...defaultPaginationConfig,
        defaultPageSize,
        total: itemsTotal,
        current: currentPage,
        onChange: onPageChange,
      }}
    >
      <Table.Column<TableData>
        title={t('transaction-id', 'ID транзакции')}
        dataIndex="id"
        width={120}
      />
      <Table.Column<TableData>
        title={t('user-id', 'ID пользователя')}
        dataIndex="userId"
        width={140}
        render={(userId: number) => (
          <Tag
            onClick={() => onUserIdClick(userId)}
            style={{
              cursor: 'pointer',
              display: 'block',
              font: 'inherit',
              margin: 0,
              textAlign: 'center',
            }}
          >
            {userId}
          </Tag>
        )}
      />
      < Table.Column<TableData>
        title={t('type', 'Тип')}
        dataIndex="type"
        render={(type: TransactionType) => transactionTypeTitles[type]}
      />
      < Table.Column<TableData>
        title={t('amount', 'Сумма')}
        dataIndex="amount"
        render={(amount: string) => `${Number(amount).toFixed(0)}₽`}
      />
      < Table.Column<TableData>
        title={t('balance-before', 'Баланс до')}
        dataIndex="balanceBefore"
        render={(amount: string) => `${Number(amount).toFixed(0)}₽`}
      />
      < Table.Column<TableData>
        title={t('balance-after', 'Баланс после')}
        dataIndex="balanceAfter"
        render={(amount: string) => `${Number(amount).toFixed(0)}₽`}
      />
      < Table.Column<TableData>
        title={t('created', 'Дата создания')}
        dataIndex="created"
        render={(date: string) => dayjs(date).format('DD.MM.YYYY HH:mm')}
      />
    </Table >
  );
};

